import React from 'react';
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, MessageCircle, CheckCircle2 } from 'lucide-react';
import { WhatsAppIcon, TikTokIcon } from './SocialIcons';
import { useFadeIn } from '../hooks/useFadeIn';
export function Contact() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  return <section id="contacto" className="py-24 bg-secondary relative overflow-hidden" data-id="element-77">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-78">
        <div ref={ref} className={`grid lg:grid-cols-2 gap-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-79">
          {/* Left Column - Info */}
          <div className="relative" data-id="element-80">
            {/* Background Hint for Left Column */}
            <div className="absolute inset-0 -mx-8 -my-12 opacity-15 pointer-events-none z-0 rounded-3xl overflow-hidden mask-image-gradient" data-id="element-81">
              <img src="https://cdn.magicpatterns.com/uploads/uvbMNKvkQxy2nwrmScqdni/9.jpg" alt="" className="w-full h-full object-cover" data-id="element-82" />
              <div className="absolute inset-0 bg-gradient-to-r from-secondary via-secondary/80 to-transparent" data-id="element-83"></div>
            </div>

            <div className="relative z-10" data-id="element-84">
              <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-85">
                Agenda tu Valoración Gratuita
              </h2>
              <p className="text-gold text-lg mb-10" data-id="element-86">
                Estamos en Pereira listos para transformar tu sonrisa
              </p>

              <div className="space-y-6 mb-10" data-id="element-87">
                <div className="flex items-start gap-4" data-id="element-88">
                  <div className="bg-primary p-3 rounded-lg border border-border text-gold" data-id="element-89">
                    <MapPin size={24} data-id="element-90" />
                  </div>
                  <div data-id="element-91">
                    <h4 className="text-white font-bold mb-1" data-id="element-92">Ubicación</h4>
                    <p className="text-gray" data-id="element-93">
                      Cra. 6 #21-37 Local 1<br data-id="element-94" />
                      Pereira, Risaralda 660001
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-95">
                  <div className="bg-primary p-3 rounded-lg border border-border text-gold" data-id="element-96">
                    <Phone size={24} data-id="element-97" />
                  </div>
                  <div data-id="element-98">
                    <h4 className="text-white font-bold mb-1" data-id="element-99">WhatsApp</h4>
                    <p className="text-gray" data-id="element-100">301 589 2967</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-101">
                  <div className="bg-primary p-3 rounded-lg border border-border text-gold" data-id="element-102">
                    <Mail size={24} data-id="element-103" />
                  </div>
                  <div data-id="element-104">
                    <h4 className="text-white font-bold mb-1" data-id="element-105">Email</h4>
                    <p className="text-gray" data-id="element-106">odontoesteticapereira@gmail.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4" data-id="element-107">
                  <div className="bg-primary p-3 rounded-lg border border-border text-gold" data-id="element-108">
                    <Clock size={24} data-id="element-109" />
                  </div>
                  <div data-id="element-110">
                    <h4 className="text-white font-bold mb-1" data-id="element-111">Horario</h4>
                    <p className="text-gray" data-id="element-112">
                      Lunes a Viernes:
                      <br data-id="element-113" />
                      8:00AM-12:00PM / 2:00PM-6:00PM
                    </p>
                  </div>
                </div>
              </div>

              {/* Social Media Icons - Mandatory Horizontal Row */}
              <div className="mb-10" data-id="element-114">
                <h4 className="text-white font-bold mb-4" data-id="element-115">Síguenos en redes</h4>
                <div className="flex flex-row gap-4 items-center" data-id="element-116">
                  <a href="https://www.instagram.com/odontologia_estetica_pereira" target="_blank" rel="noopener noreferrer" className="bg-primary p-3 rounded-lg border border-border text-white hover:text-gold hover:border-gold transition-colors" data-id="element-117">
                    <Instagram size={24} data-id="element-118" />
                  </a>
                  <a href="#" target="_blank" rel="noopener noreferrer" className="bg-primary p-3 rounded-lg border border-border text-white hover:text-gold hover:border-gold transition-colors" data-id="element-119">
                    <Facebook size={24} data-id="element-120" />
                  </a>
                  <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="bg-primary p-3 rounded-lg border border-border text-white hover:text-gold hover:border-gold transition-colors" data-id="element-121">
                    <WhatsAppIcon size={22} data-id="element-122" />
                  </a>
                  <a href="https://www.tiktok.com/@odontologia_estetica_pereira" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="bg-primary p-3 rounded-lg border border-border text-white hover:text-gold hover:border-gold transition-colors" data-id="element-123">
                    <TikTokIcon size={22} data-id="element-124" />
                  </a>
                </div>
              </div>

              <a href="https://wa.me/573015892967" target="_blank" rel="noopener noreferrer" className="w-full flex items-center justify-center gap-2 bg-[#25D366] hover:bg-[#20bd5a] text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-125">
                <MessageCircle size={20} data-id="element-126" /> Escribir por WhatsApp Ahora
              </a>
            </div>
          </div>

          {/* Right Column - Form */}
          <div className="bg-card border border-gold/30 rounded-2xl p-8 shadow-2xl relative z-10" data-id="element-127">
            <h3 className="font-serif text-2xl text-white mb-2" data-id="element-128">
              Solicita tu Valoración
            </h3>
            <p className="text-gold text-sm mb-8" data-id="element-129">
              Respuesta en menos de 24 horas
            </p>

            <form className="space-y-5" onSubmit={e => e.preventDefault()} data-id="element-130">
              <div data-id="element-131">
                <label htmlFor="name" className="block text-sm font-medium text-gray mb-1" data-id="element-132">
                  Nombre completo *
                </label>
                <input type="text" id="name" required className="w-full bg-primary border border-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Tu nombre" data-id="element-133" />
              </div>

              <div data-id="element-134">
                <label htmlFor="phone" className="block text-sm font-medium text-gray mb-1" data-id="element-135">
                  Teléfono (WhatsApp) *
                </label>
                <input type="tel" id="phone" required className="w-full bg-primary border border-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors" placeholder="Tu número" data-id="element-136" />
              </div>

              <div data-id="element-137">
                <label htmlFor="treatment" className="block text-sm font-medium text-gray mb-1" data-id="element-138">
                  Tratamiento de interés
                </label>
                <select id="treatment" className="w-full bg-primary border border-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors appearance-none" data-id="element-139">
                  <option value="" data-id="element-140">Selecciona una opción</option>
                  <option value="mini" data-id="element-141">
                    Mini Diseño de Sonrisa - $1.800.000
                  </option>
                  <option value="resina" data-id="element-142">
                    Diseño de Sonrisa en Resina - $3.200.000
                  </option>
                  <option value="estratificado" data-id="element-143">
                    Diseño Sonrisa Estratificado - $4.200.000
                  </option>
                  <option value="ceramica" data-id="element-144">
                    Diseño en Cerámica - $9.900.000
                  </option>
                  <option value="blanqueamiento" data-id="element-145">
                    Blanqueamiento Dental - $800.000
                  </option>
                  <option value="completo" data-id="element-146">
                    Diseño Completo en Cerámica - $18.500.000
                  </option>
                  <option value="otro" data-id="element-147">Otro / No sé cuál necesito</option>
                </select>
              </div>

              <div data-id="element-148">
                <label htmlFor="message" className="block text-sm font-medium text-gray mb-1" data-id="element-149">
                  Mensaje (Opcional)
                </label>
                <textarea id="message" rows={4} className="w-full bg-primary border border-border rounded-lg px-4 py-3 text-white focus:outline-none focus:border-gold focus:ring-1 focus:ring-gold transition-colors resize-none" placeholder="Cuéntanos un poco sobre lo que buscas..." data-id="element-150"></textarea>
              </div>

              <button type="submit" className="w-full bg-gold hover:bg-gold-hover text-primary font-bold px-8 py-4 rounded-lg transition-colors mt-4 flex justify-center items-center gap-2" data-id="element-151">
                <CheckCircle2 size={20} data-id="element-152" /> Solicitar Mi Valoración Gratis
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>;
}